import { BaseBadge } from 'app/components/common/BaseBadge'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseRow } from 'app/components/common/BaseRow'
import BaseText from 'app/components/common/BaseText'
import { convertedVariables } from 'app/styles/themes/themeVariables'
import { isEqual } from 'lodash'

export enum TabKeysEnum {
  OPEN = '1',
  WAITING = '2',
  ACCEPTED = '3',
  REJECTED = '4',
  CANCELED = '5'
}

export const LabelComponent = ({
  tabActive,
  label,
  tabKey,
  count,
}: {
  tabActive: string
  tabKey: TabKeysEnum
  label: string
  count?: number
}) => {
  return (
    <BaseRow gutter={8} align={'middle'} style={{position: 'relative'}}>
      <BaseCol>
        <BaseText
          fontWeight="medium"
          fontSize="xs"
          children={label}
          colorText={
            isEqual(tabActive, tabKey)
              ? 'collapseBackgroundColor'
              : 'primaryColor'
          }
        />
      </BaseCol>
      <BaseCol>
        <BaseBadge
          color={
            convertedVariables[
              isEqual(tabActive, tabKey)
                ? 'collapseBackgroundColor'
                : 'primaryColor'
            ]
          }
          count={count}
          
        />
      </BaseCol>
    </BaseRow>
  )
}
